import { render } from "./Header.vue?vue&type=template&id=85160a90&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=85160a90&lang=css"
import "./Header.vue?vue&type=style&index=1&id=85160a90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85160a90"],['__file',"src/components/Dashboard/Header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "85160a90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('85160a90', __exports__)) {
    api.reload('85160a90', __exports__)
  }
  
  module.hot.accept("./Header.vue?vue&type=template&id=85160a90&scoped=true", () => {
    api.rerender('85160a90', render)
  })

}


export default __exports__